window.addEventListener('UC_UI_INITIALIZED', function(event) {
    verifyConsent();

    window.addEventListener("onConsentChange", function (e) {
        if (e.detail.event == "consent_status") {
            var consents = window.UC_UI.getServicesBaseInfo();
            $.each(consents, function(index, consent) {
                if (consent.consent.status === true) {
                    removeConfirmLayer(consent.name);
                }
            });
            verifyConsent();
        }
    });
});
  
var ucSettings = {
    confirmTitle: 'Wir brauchen dein Einverständnis',
    confirmText: {
        'YouTube Video': 'Um Videoinhalte einbinden zu können, nutzen wir die Services von Drittanbietern. Diese sammeln unter Umständen Daten zu deinen Aktivitäten. Unter dem Punkt „Mehr Informationen“ findest du weitere Details.',
        'Infogram': 'Um Infografiken einbinden zu können, nutzen wir die Services von Drittanbietern. Diese sammeln unter Umständen Daten zu deinen Aktivitäten. Unter dem Punkt „Mehr Informationen“ findest du weitere Details.',
        'Microsoft Forms': 'Um Umfragen einbinden zu können, nutzen wir die Services von Drittanbietern. Diese sammeln unter Umständen Daten zu deinen Aktivitäten. Unter dem Punkt „Mehr Informationen“ findest du weitere Details.',
        'Podigee': 'Um Podcasts einbinden zu können, nutzen wir die Services von Drittanbietern. Diese sammeln unter Umständen Daten zu deinen Aktivitäten. Unter dem Punkt „Mehr Informationen“ findest du weitere Details.'
    },
    infoLinkText: 'Mehr Informationen',
    confirmLinkText: 'Akzeptieren',
    errorTitle: 'Entschuldigung',
    errorText: 'Bei der Anzeige der Anwendung scheint etwas schief gelaufen zu sein. Bitte probiere es später noch einmal.'
}
  
function verifyConsent() {
    $('.confirm-app').each(function(index) {
        var appContainer = $(this);
        if (typeof window.UC_UI !== 'undefined') {

            var ucData = window.UC_UI.getServicesBaseInfo().find(x => x.id === appContainer.data('uc-template-id'));

            if (window.UC_UI && ucData.consent.status !== true) {
                appendConfirmLayer(appContainer);
                appContainer.addClass('confirm-wrapper');
            } else {
                appContainer.removeClass('confirm-wrapper');
            }
        } else {
            appendErrorLayer(appContainer);
        }
    });
  
    $('.confirm-container').each(function(index) {
        var appContainer = $(this);
        if (typeof window.UC_UI !== 'undefined') {
            var ucData = window.UC_UI.getServicesBaseInfo().find(x => x.id === appContainer.data('uc-template-id'));
            if (window.UC_UI && ucData.consent.status !== true) {
                appContainer.hide();
            } else {
                appContainer.show();
            }
        }
    });
}
  
function appendConfirmLayer(appContainer) {
    var templateID = appContainer.data('uc-template-id'),
        ucType = appContainer.data('uc-type'),
        confirmLayer = $('<div class="confirm-layer wysiwyg"></div>'),
        confirmTitle = $('<h3>' + ucSettings.confirmTitle + '</h3>'),
        confirmText = $('<p>' + ucSettings.confirmText[ucType] + '</p>'),
        confirmCta = $('<div class="cta"></div>'),
        infoLink = $('<a href="#" class="btn btn-secondary">' + ucSettings.infoLinkText + '</a>'),
        confirmLink = $('<a href="#" class="btn btn-primary confirm-link">' + ucSettings.confirmLinkText + '</a>');

    appContainer.children('.confirm-layer').remove();
    appContainer.append(confirmLayer);
    confirmLayer.append(confirmTitle, confirmText, confirmCta);
    confirmCta.append(infoLink, confirmLink);

    infoLink.on('click', function(e) {
        window.UC_UI.showSecondLayer(templateID);
        e.preventDefault();
    });

    confirmLink.on('click', function(e) {
        window.UC_UI.acceptService(templateID);
        removeConfirmLayer(ucType);
        e.preventDefault();
    });
}
  
function appendErrorLayer(appContainer) {
    var errorTitle = $('<h3>' + ucSettings.errorTitle + '</h3>'),
        errorText = $('<p>' + ucSettings.errorText + '</p>'),
        confirmLayer = $('<div class="confirm-layer wysiwyg"></div>');
  
    appContainer.append(confirmLayer);
    confirmLayer.append(errorTitle, errorText);
}
  
function removeConfirmLayer(type) {
    $('[data-uc-type="' + type + '"] .confirm-layer').remove();
}

function initYouTube() {
	$('.confirm-youtube').each(function() {
        $(this).append('<iframe src="' + $(this).data('source') + '" allowfullscreen frameborder="0"/>');
  });
}

function initInfogram() {
	$('.confirm-infogram').each(function() {
        $(this).append('<iframe src="' + $(this).data('source') + '" allowfullscreen frameborder="0"/>');
  });
}

function initMicrosoftForms() {
	$('.confirm-microsoft-forms').each(function() {
        $(this).append('<iframe src="' + $(this).data('source') + '" allowfullscreen frameborder="0"/>');
  });
}

function initPodigee() {
	$('.confirm-podigee').each(function() {
        $(this).append('<script class="podigee-podcast-player" src="https://player.podigee-cdn.net/podcast-player/javascripts/podigee-podcast-player.js" data-configuration="' + $(this).data('source') + '/embed?context=external" allowfullscreen frameborder="0"/>');
  });
}